import moment from 'moment';

export const getCurrentDate = (amount) => {
    if (amount === 0) {
        return moment().format('YYYY-MM-DD');
    } else {
        return moment().add(amount || 1, 'day').format('YYYY-MM-DD');
    }
};
